import { GridRenderCellParams } from '@mui/x-data-grid-premium';
import type { EntityName, FeatureName, SecurityAction } from '../../auth/Security';
import type { DataGridCustomRowAction } from './types';

interface DataGridCustomRowActionsFilterOptions {
    shouldUseCentralizedSecurityFramework: boolean;
    evaluateSecurity: (
        securityAction: SecurityAction,
        context: {
            entityName: EntityName;
            entitySecurity: Record<string, boolean>;
            featureName?: FeatureName;
        }
    ) => {
        allowed: boolean;
    };
    resolvedRowPermissions: Record<SecurityAction, boolean>;
    entityName: EntityName;
    params: GridRenderCellParams;
}

export function filterCustomRowActionsForVisibilityAndSecurity(
    customRowActions: DataGridCustomRowAction[],
    {
        shouldUseCentralizedSecurityFramework,
        evaluateSecurity,
        resolvedRowPermissions,
        entityName,
        params
    }: DataGridCustomRowActionsFilterOptions
): DataGridCustomRowAction[] {
    const filteredCustomRowActions: DataGridCustomRowAction[] = customRowActions.filter((action) => {
        const isActionVisible = action.isVisible ? action.isVisible(params.row) : true;

        let isActionPermitted = false;
        if (shouldUseCentralizedSecurityFramework) {
            const { allowed } = evaluateSecurity(action.securityAction, {
                entityName,
                entitySecurity: params.row.security,
                featureName: action.featureName
            });
            isActionPermitted = allowed;
        } else {
            isActionPermitted = resolvedRowPermissions[action.securityAction];
        }

        return isActionVisible && isActionPermitted;
    });

    return filteredCustomRowActions;
}
